var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import MulShopOamount from "./MulShopOamount.vue";
import { summaries } from "../../helper/util";
import { add } from "../../helper/calucate";
import ELogisticsType from "../../enum/ELogisticsType";
import { EPurOrderStatus } from "../../enum/EStatus";
import EOrderFromSystem from "../../enum/EOrderFromSystem";
import { mapGetters } from "vuex";
import SelectStockBatch from '../deliver/component/SelectStockBatch.vue';
var GoodTable = (function (_super) {
    __extends(GoodTable, _super);
    function GoodTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.mulShopList = [];
        _this.eLogisticsType = ELogisticsType;
        _this.purOrderStatus = EPurOrderStatus;
        _this.eOrderFromSystem = EOrderFromSystem;
        return _this;
    }
    GoodTable.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            var diff = _this.billData.logistics_type == ELogisticsType.Straight || _this.billData.logistics_type == ELogisticsType.VirtualStraight ? 300 : 220;
            _this.tableHeight = document.documentElement.clientHeight - diff;
        }, 300);
    };
    GoodTable.prototype.selectStockBatch = function (row) {
        this.$refs.SelectStockBatch.show(row);
    };
    GoodTable.prototype.add = function (a, b) {
        return add(a, b);
    };
    GoodTable.prototype.showShopDetail = function (row) {
        var _this = this;
        this.mulShopList = JSON.parse(JSON.stringify(row.shop_items || []));
        this.mulShopList.forEach(function (item) {
            item["logistics_type"] = _this.billData.logistics_type;
        });
        this.$refs.mulShop.showRelease();
    };
    GoodTable.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ["order_detail_amount", "order_gift_amount", "order_gift_oamount", "order_detail_oamounted_total", "total_price", 'order_detail_reduction_money', 'total_goods_price'];
        sums = summaries(param, showSum);
        sums[0] = '单据合计';
        return sums;
    };
    __decorate([
        Prop({
            type: Array,
            default: [],
        })
    ], GoodTable.prototype, "tableData", void 0);
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], GoodTable.prototype, "type", void 0);
    __decorate([
        Prop({
            type: Object,
            default: {},
        })
    ], GoodTable.prototype, "billData", void 0);
    GoodTable = __decorate([
        Component({
            components: {
                "mul-shop-oamount": MulShopOamount,
                'select-stock-batch': SelectStockBatch,
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus',
                canSelectBatch: 'canSelectBatch',
            }), { isHideGiftAmount: function () {
                    var billData = this.billData || {};
                    return (billData.logistics_type === 2 && billData.depot_in_model === 1) || [4, 5].includes(billData.logistics_type);
                },
                isHideGiftOAmount: function () {
                    var billData = this.billData || {};
                    return this.isHideGiftAmount || [EPurOrderStatus.ToAudit, EPurOrderStatus.Bconfirm, EPurOrderStatus.Invalid].includes(billData.order_sup_status + '');
                },
                orderHasMerge: function () {
                    var isStraight = this.billData.logistics_type == this.eLogisticsType.Straight;
                    var isVirtualStraight = this.billData.logistics_type == this.eLogisticsType.VirtualStraight;
                    var isDirect = this.billData.logistics_type == this.eLogisticsType.Direct && this.billData.depot_in_type == 1;
                    var isCustomer = this.billData.from_system === EOrderFromSystem['客户系统'];
                    var hasMerge = (isStraight || isVirtualStraight || isDirect) && isCustomer;
                    return hasMerge;
                },
                displayTableData: function () {
                    var tableData = this.tableData || [];
                    return tableData.map(function (item) {
                        item.order_detail_oamounted_total = add(item.order_detail_oamounted, item.order_gift_oamount);
                        if (item.items) {
                            item.items = item.items.map(function (row) {
                                row.order_detail_oamounted_total = add(row.order_detail_oamounted, row.order_gift_oamount);
                                return row;
                            });
                        }
                        return item;
                    });
                },
                isShowPrice: function () {
                    return this.billData.is_show_uprice == 1;
                },
                hideColumnFields: function () {
                    return this.billData.order_sup_status == this.purOrderStatus.Invalid || +this.billData.from_system !== 1 ? ['receive_send_amount_diff'] : [];
                } })
        })
    ], GoodTable);
    return GoodTable;
}(Vue));
export default GoodTable;
